export default "__VITE_ASSET__a46ca59b__"